import { render, staticRenderFns } from "./Multi.vue?vue&type=template&id=6a21b2a4&"
import script from "./Multi.vue?vue&type=script&lang=ts&"
export * from "./Multi.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports